import React from "react";
import { Route, Redirect } from "react-router-dom";

const auth = sessionStorage.getItem("auth_user") ? true : false;

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    render={(props) =>
      auth ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
    {...rest}
  />
);
